<template>
  <div class="divider mt-2 mb-2">
    <v-divider class="mt-1 mb-1"></v-divider>
  </div>
</template>

<script>
export default {
  name: "Divider"
};
</script>

<style>
.divider {
  width: 100%;
}
</style>